import { render, staticRenderFns } from "./quizItem.vue?vue&type=template&id=75680a9d&"
import script from "./quizItem.vue?vue&type=script&lang=js&"
export * from "./quizItem.vue?vue&type=script&lang=js&"
import style0 from "./quizItem.vue?vue&type=style&index=0&id=75680a9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports